import { WidgetConfig, WidgetType } from '../../../types'
import {
	ActualMilkYieldWidget,
	AvgConnectTime,
	AvgMilkingTime,
	AvgMilkYield,
	CritFatnessHead,
	DeviationsCarousel,
	DeviationsFeedTableWidget,
	DeviationsParallel,
	DisposeRecommendedWidget,
	DryHerd,
	FatnessWidget,
	FeedAvailabilityAvg,
	FeedConsumptionBarChart,
	FeedConsumptionLineChart,
	FeedConsumptionWidget,
	FeedConsumptionWidgetSmall,
	HerdAll,
	HerdStructureWidget,
	IdentificateWidget,
	IdentificateWithNotifMedium,
	IdentificateWithNotifWidget,
	LameHeads,
	LamenessWidget,
	LargeHerdStructureWidget,
	MilkingDeviationsWidget,
	MilkyHerd,
	MilkYieldLinearChart,
	PsvAvgDry,
	PsvAvgMilky,
	PsvDynamicChart,
	PsvHerdStructureWidget,
	RejectedMilkYieldWidget,
	RemainingFeedProcent,
	RemainingFeedWidgetSmall,
} from '../../widgets'
import { FeedAvailabilityWidget } from '../../widgets/feed-availability'
import { FeedPlanCompliance } from '../../widgets/feed-plan-compliance'
import { PsvWidget } from '../../widgets/psv/components/psv-small/psv-widget'

export const renderWidgetContent = (widget: WidgetConfig) => {
	switch (widget.type) {
		case WidgetType.HERD_STRUCTURE:
			return <HerdStructureWidget />

		case WidgetType.IDENTIFICATE:
			return <IdentificateWidget />
		case WidgetType.FATNESS_DONUT_CHART:
			return <FatnessWidget />
		case WidgetType.ACTUAL_YIELD:
			return <ActualMilkYieldWidget />
		case WidgetType.PSV_HERD_STRUCTURE:
			return <PsvHerdStructureWidget />
		case WidgetType.DISPOSE_RECOMMENDED:
			return <DisposeRecommendedWidget />
		case WidgetType.REJECTED_MILK_YIELD:
			return <RejectedMilkYieldWidget />

		case WidgetType.MILKING_DEVIATIONS:
			return <MilkingDeviationsWidget />
		case WidgetType.FEED_AVAILABILITY:
			return <FeedAvailabilityWidget />
		case WidgetType.LAMENESS_LINE_CHART:
			return <LamenessWidget />
		case WidgetType.DEVIATIONS_FEED_TABLE:
			return <DeviationsFeedTableWidget />
		case WidgetType.LARGE_HERD_STRUCTURE:
			return <LargeHerdStructureWidget />
		case WidgetType.MILKY_HERD:
			return <MilkyHerd />
		case WidgetType.DRY_HERD:
			return <DryHerd />

		case WidgetType.HERD_ALL:
			return <HerdAll />

		case WidgetType.IDENTIFICATE_WITH_NOTIF:
			return <IdentificateWithNotifWidget />

		case WidgetType.IDENTIFICATE_WITH_NOTIF_MEDIUM:
			return <IdentificateWithNotifMedium />

		case WidgetType.FEED_CONSUMPTION:
			return <FeedConsumptionWidget />
		case WidgetType.FEED_CONSUMPTION_SMALL:
			return <FeedConsumptionWidgetSmall />
		case WidgetType.REMAINING_FEED_SMALL:
			return <RemainingFeedWidgetSmall />

		case WidgetType.FEED_CONSUMPTION_LINE_CHART:
			return <FeedConsumptionLineChart />

		case WidgetType.FEED_CONSUMPTION_BAR_CHART:
			return <FeedConsumptionBarChart />
		case WidgetType.REMAINING_FEED_PROCENT:
			return <RemainingFeedProcent />
		case WidgetType.PSV_DYNAMIC_CHART:
			return <PsvDynamicChart />
		case WidgetType.PSV_AVG_MILKY:
			return <PsvAvgMilky />

		case WidgetType.PSV_AVG_DRY:
			return <PsvAvgDry />
		case WidgetType.PSV_WIDGET:
			return <PsvWidget />

		case WidgetType.FEED_AVAILABILITY_AVG:
			return <FeedAvailabilityAvg />
		case WidgetType.FEED_PLAN_COMPLIANCE:
			return <FeedPlanCompliance />
		case WidgetType.LAME_HEADS:
			return <LameHeads />
		case WidgetType.CRIT_FATNESS_HEAD:
			return <CritFatnessHead />

		case WidgetType.AVG_MILKING_TIME:
			return <AvgMilkingTime />
		case WidgetType.AVG_CONNECT_TIME:
			return <AvgConnectTime />

		case WidgetType.DEVIATIONS_CAROUSEL:
			return <DeviationsCarousel />
		case WidgetType.DEVIATIONS_PARALLEL:
			return <DeviationsParallel />

		case WidgetType.AVG_MILK_YIELD:
			return <AvgMilkYield />

		case WidgetType.MILK_YIELD_LINEAR_CHART:
			return <MilkYieldLinearChart />
	}
}
